import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider } from './context/AuthContext';
import Layout from './components/Layout/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import { ROUTES } from './utils/constants';

// Pages
import HomePage from './pages/HomePage';
import GamesPage from './pages/GamesPage';
import MyPicksPage from './pages/MyPicksPage';
import ArenaPage from './pages/ArenaPage';
import ProfileSettingsPage from './pages/ProfileSettingsPage';
import FriendsPage from './pages/FriendsPage';
import StatsPage from './pages/StatsPage';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/RegisterPage';
import PickFlowPage from './pages/PickFlowPage';
import UserProfilePage from './pages/UserProfilePage';
import BoutStandingsPage from './pages/BoutStandingsPage';
import BoutHistoryPage from './pages/BoutHistoryPage';

import './App.css';

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: '#16213e',
              color: '#fff',
              border: '1px solid rgba(255,255,255,0.1)',
            },
          }}
        />
        <Routes>
          {/* Auth pages (no layout header) */}
          <Route path={ROUTES.LOGIN} element={<LoginPage />} />
          <Route path={ROUTES.REGISTER} element={<RegisterPage />} />

          {/* Routes with layout */}
          <Route element={<Layout />}>
            {/* Public — anyone can browse games and arena */}
            <Route path={ROUTES.HOME} element={<HomePage />} />
            <Route path={ROUTES.GAMES} element={<GamesPage />} />
            <Route path={ROUTES.ARENA} element={<ArenaPage />} />
            <Route
              path={ROUTES.BOUT}
              element={
                <ProtectedRoute>
                  <BoutStandingsPage />
                </ProtectedRoute>
              }
            />
            <Route path="/leaderboard" element={<Navigate to="/arena" replace />} />
            <Route path={ROUTES.USER_PROFILE} element={<UserProfilePage />} />
            <Route
              path={ROUTES.PICK}
              element={
                <ProtectedRoute>
                  <PickFlowPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.MY_PICKS}
              element={
                <ProtectedRoute>
                  <MyPicksPage />
                </ProtectedRoute>
              }
            />
            {/* Profile sub-pages */}
            <Route
              path={ROUTES.PROFILE}
              element={
                <ProtectedRoute>
                  <Navigate to={ROUTES.PROFILE_SETTINGS} replace />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.PROFILE_SETTINGS}
              element={
                <ProtectedRoute>
                  <ProfileSettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.PROFILE_FRIENDS}
              element={
                <ProtectedRoute>
                  <FriendsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.PROFILE_STATS}
              element={
                <ProtectedRoute>
                  <StatsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path={ROUTES.PROFILE_BOUT_HISTORY}
              element={
                <ProtectedRoute>
                  <BoutHistoryPage />
                </ProtectedRoute>
              }
            />
          </Route>
        </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
